"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetUserMarkedHelpfulSelector = exports.getReviewStats = exports.getReviews = exports.getReviewsState = void 0;

var _reselect = require("reselect");

var _auth = require("./auth");

var getReviewsState = function getReviewsState(state) {
  return state.reviews;
};

exports.getReviewsState = getReviewsState;
var getReviews = (0, _reselect.createSelector)([getReviewsState], function (reviewsState) {
  return reviewsState.get('list');
});
exports.getReviews = getReviews;
var getReviewStats = (0, _reselect.createSelector)([getReviewsState], function (reviewsState) {
  return reviewsState.get('stats');
}); // Selector factory enables us to pass props into useSelector and maintain memoization

exports.getReviewStats = getReviewStats;

var makeGetUserMarkedHelpfulSelector = function makeGetUserMarkedHelpfulSelector() {
  return (0, _reselect.createSelector)([getReviews, _auth.getUserId, function (_, reviewId) {
    return reviewId;
  }], function (reviews, userId, reviewId) {
    var review = reviews.find(function (rev) {
      return rev.get('id') === reviewId;
    });
    return review && review.get('attributes').some(function (attr) {
      return attr.get('userId') === userId && attr.get('helpful');
    });
  });
};

exports.makeGetUserMarkedHelpfulSelector = makeGetUserMarkedHelpfulSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/reviews.js
// module id = 288
// module chunks = 209 210 211 212